$(document).ready(function() {
    $('#card_1 .check_box').on('click', function(e) {
        e.preventDefault();
        $('#card_1').css({ display: 'none' });
        $('.addition_code_box').css({ display: 'none' });
        $('#code_title').css({ display: 'none' });
        $('#card_2').css({ display: 'flex' });
        $('.addition_online_box').css({ display: 'flex' });
        $('#online_title').css({ display: 'block' });
    });

    $('#card_2 .check_box').on('click', function(e) {
        e.preventDefault();
        $('#card_2').css({ display: 'none' });
        $('.addition_online_box').css({ display: 'none' });
        $('#online_title').css({ display: 'none' });
        $('#card_1').css({ display: 'flex' });
        $('.addition_code_box').css({ display: 'flex' });
        $('#code_title').css({ display: 'block' });
    });
});